"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GRID_COMMA_LIST_COL_DEF = void 0;
var _Cell = _interopRequireDefault(require("../components/Cell"));
var _styles = require("@gogame/ui/styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Primary = (0, _styles.styled)('span')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: pointer;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.primary.main;
});
var GRID_COMMA_LIST_COL_DEF = exports.GRID_COMMA_LIST_COL_DEF = {
  getItemValue: function getItemValue(el) {
    return el.name;
  },
  getValue: function getValue(v, _, column) {
    var getItemValue = column.getItemValue;
    return v === null || v === void 0 ? void 0 : v.map(getItemValue);
  },
  limit: 2,
  formatter: function formatter(v, row, column) {
    var limit = column.limit,
      _column$unitsLabel = column.unitsLabel,
      unitsLabelProp = _column$unitsLabel === void 0 ? '' : _column$unitsLabel,
      headerName = column.headerName;
    if ((v === null || v === void 0 ? void 0 : v.length) > limit) {
      var unitsLabel = unitsLabelProp;
      if (!unitsLabel && headerName) {
        unitsLabel = (0, _utils.getUnitsNameFromLabel)(headerName);
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Primary, {
        children: [v.length, " ", unitsLabel]
      });
    }
    return v === null || v === void 0 ? void 0 : v.join(', ');
  },
  getTooltip: function getTooltip(v) {
    return v === null || v === void 0 ? void 0 : v.join(', ');
  },
  renderCell: function renderCell(params) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cell["default"], _objectSpread({}, params));
  }
};